import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setGetSearchList } from '../../store/thunk/setGetSearchList';
import TemplatePage from '../../../components/templatePage';
import GameItem from '../../components/gameItem';
import { setLoadingAction } from '../../../components/templatePage/store/action';

const handleLoadPagination = ({page, setPage, countPage, dispatch}) => {
    if (page <= countPage) {
        dispatch(setGetSearchList({
            page: page + 1,
            rowsPerPage: 25,
            search: ''
        }));
        setPage(page + 1);
    }
}

const handleLoading = (dispatch) => {
    dispatch(setLoadingAction(true))
}

const GamesSearch = () => {
    const [page, setPage] = React.useState(1);
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(setGetSearchList({
            search: '',
            page: 1,
            rowsPerPage: 25
        }))
    }, []);

    const list = useSelector(state => state.providerMobile.search);
   
    return (
        <TemplatePage
            title="Поиск по играм"
            pagination={page < list.countPage && list.data.length}
            handleLoadPagination={() => handleLoadPagination({
                page,
                setPage,
                countPage: list.countPage,
                dispatch
            })}
            handleLoading={() => handleLoading(dispatch)}
        >
            {
                list.data.map((item, key) => <GameItem item={item} key={key}/>)
            }
        </TemplatePage>
    )
}

export default GamesSearch;